import type { ComponentType, ReactNode } from 'react';

import { cn } from '../lib/utils';
import { Panel } from './ui/panel';

interface EmptyStateProps {
  icon?: ComponentType<{ className?: string }>;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <Panel
      className={cn('flex flex-col items-center gap-3 halftone px-6 py-12 text-center', className)}
    >
      {Icon ? (
        <span className="grid size-12 place-items-center rounded-full bg-surface-raised text-accent">
          <Icon className="size-6" />
        </span>
      ) : null}
      <h3 className="text-xl text-foreground">{title}</h3>
      {description ? <p className="max-w-sm text-sm text-muted">{description}</p> : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </Panel>
  );
}
